import { z } from "zod/v4";

import {
  DiscountApplicationMethodList,
  DiscountDiscountTypeList,
  DiscountUnitTypeList,
} from "./offers";
import {
  ShippingCountryFilterSchema,
  ShippingRateFilterSchema,
} from "./shipping-discount";

const ExperienceMetafieldSchema = z.object({
  id: z.string(),
  variationIds: z.string().array(),
});

export type ExperienceMetafieldType = z.infer<typeof ExperienceMetafieldSchema>;

export const OfferEligibilityValidationList = ["none", "cart"] as const;
export type OfferEligibilityValidation =
  (typeof OfferEligibilityValidationList)[number];

const AutomaticDiscountTierMetafieldSchema = z.object({
  minimumUnits: z.number(),
  unitDiscount: z.number(),
  discountTitle: z.string().optional(),
  isGiftWithPurchase: z.boolean(),
  giftWithPurchaseProductId: z.string().optional(),
  giftWithPurchaseVariantId: z.string().optional(),
  giftWithPurchaseTitle: z.string().optional(),
  hasShippingDiscount: z.boolean(),
});

export type AutomaticDiscountTierMetafield = z.infer<
  typeof AutomaticDiscountTierMetafieldSchema
>;

const ShippingDiscountMetafieldSchema = z.object({
  discountType: z.enum(["percentage", "dollar"]),
  unitDiscount: z.number(),
  rateFilter: ShippingRateFilterSchema.optional(),
  countryFilter: ShippingCountryFilterSchema.optional(),
  discountLabel: z.string().optional(),
});

export type ShippingDiscountMetafield = z.infer<
  typeof ShippingDiscountMetafieldSchema
>;

const AutomaticDiscountMetafieldSchema = z.object({
  id: z.string(),
  excludeProducts: z.boolean(),
  includeProducts: z.boolean(),
  productList: z.record(z.string(), z.literal(true)).optional(),
  discountType: z.enum(DiscountDiscountTypeList),
  unitType: z.enum(DiscountUnitTypeList),
  discountApplicationMethod: z.enum(DiscountApplicationMethodList),
  maximumDollarDiscount: z.number().optional(),
  tiers: AutomaticDiscountTierMetafieldSchema.array().default([]),
  shippingDiscount: ShippingDiscountMetafieldSchema.optional(),
  combinesWithIntelligems: z.boolean(),
  eligibilityValidation: z.enum(OfferEligibilityValidationList),
});

export type AutomaticDiscountMetafield = z.infer<
  typeof AutomaticDiscountMetafieldSchema
>;
